export default {
  formsList: [],
  questionsByFormId: [],
  currentFormId: null,
  errors: null
};
